/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type DashboardStatus, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/UpdateStatus
 */
export interface UpdateStatusRequestBuilder extends BaseRequestBuilder<UpdateStatusRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<UpdateStatusRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<UpdateStatusRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface UpdateStatusRequestBuilderPostQueryParameters {
    dashboardBookingId?: number;
    status?: DashboardStatus;
}
/**
 * Uri template for the request builder.
 */
export const UpdateStatusRequestBuilderUriTemplate = "{+baseurl}/Dashboard/UpdateStatus?dashboardBookingId={dashboardBookingId}&status={status}";
/**
 * Metadata for all the requests in the request builder.
 */
export const UpdateStatusRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: UpdateStatusRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
